define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.normalizeLocalDateTime = void 0;
    const normalizeLocalDateTime = (value) => {
        if (value == null) {
            return undefined;
        }
        if (typeof value === "string") {
            const trimmed = value.trim();
            if (!trimmed || trimmed.toLowerCase() === "invalid date") {
                return undefined;
            }
            const ldtPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/;
            if (ldtPattern.test(trimmed)) {
                return trimmed;
            }
            const d = new Date(trimmed);
            if (!isNaN(d.getTime())) {
                return d.toISOString().replace("Z", "");
            }
            return undefined;
        }
        if (typeof value === "number") {
            const ms = value < 1e12 ? value * 1000 : value;
            const d = new Date(ms);
            if (!isNaN(d.getTime())) {
                return d.toISOString().replace("Z", "");
            }
            return undefined;
        }
        if (value instanceof Date) {
            if (!isNaN(value.getTime())) {
                return value.toISOString().replace("Z", "");
            }
            return undefined;
        }
        return undefined;
    };
    exports.normalizeLocalDateTime = normalizeLocalDateTime;
});
